import { downloadData, getUrl } from "aws-amplify/storage";
import { apiGetSensor, apiListCameraImagePastFlood, apiListCameraSensorHistories6hAgo } from "apis/SensorApi";
import Icon, { IconList } from "components/Icon";
import { DIALOG_ERROR_GENERAL_ERROR_MESSAGE, TEXT_BASE_DISPLAY } from "constants/message";
import { useAuth } from "context/AuthContext";
import { useGeneralSetting } from "context/GeneralSettingContext";
import { useSensorGroups } from "context/SensorGroupsContext";
import { SensorType } from "models";
import CameraDisplayer from "pages/components/CameraDisplayer";
import CameraTrafficVolumeChart from "pages/SensorList/components/CameraTrafficVolumeChart";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import MiniMapView from "./components/MiniMap";
import { IconSensor } from "pages/SensorList/components/SensorDetailHeader";
import "./BasePage.css";
import PropTypes from 'prop-types';
import { downloadExcelWithSensorData } from "./helpers";
import FanLoadingIcon from "components/FanLoadingIcon";
import moment from 'moment-timezone';
import { AccountType } from "models";
import { downloadBlob } from "pages/SensorList/helper";
import { createPortal } from "react-dom";
import { useDialog } from "context/DialogContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { TARGET_ZOOM_CAMERA } from "constants/config";
import ImageZoom from "./components/ImageZoom";

const propTypes = {
  onViewSensorDetail: PropTypes.func,
};
const defaultProps = {
  onViewSensorDetail: (sensor) => { },
};

const ZoomDataCapture = ({ size, setZoomData }) => {
  useEffect(() => {
    setZoomData((prevData) => {
      if (prevData.src) {
        if (prevData.size?.width !== size?.width || prevData.size?.height !== size?.height) {
          return { ...prevData, size: size };
        }
        return prevData;
      }
      return { ...prevData, size: size };
    });
  }, [size, setZoomData]);
  return null;
};

const CameraSensorInfo = ({ targetSensor, targetGroup, onViewSensorDetail, generalSetting }) => {
  const [listImageKey6hAgoCamera1, setListImageKey6hAgoCamera1] = useState([]);
  const [listImageKey6hAgoCamera2, setListImageKey6hAgoCamera2] = useState([]);
  const [listPastFloodImageKeyCamera1, setListPastFloodImageKeyCamera1] = useState([]);
  const [listPastFloodImageKeyCamera2, setListPastFloodImageKeyCamera2] = useState([]);
  const [showPastFloodButton, setShowPastFloodButton] = useState(false);
  const [image1Src, setImage1Src] = useState("");
  const [image2Src, setImage2Src] = useState("");
  const [typeDisplayCamera, setTypeDisplayCamera] = useState(targetSensor.data.typeDisplayCamera || "IMAGE");
  const [loading, setLoading] = useState(false);
  const [zoomData, setZoomData] = useState({ src: null, size: null });
  const intervalRef1 = useRef(null);
  const intervalRef2 = useRef(null);
  const { currentUser } = useAuth();
  const { error } = useDialog();
  const { keyNewestImage, swapImageCamera, keyNewestImage2, cameraFeature, typeCamera, zoomImageFeature, zoomTargetCamera, zoomCenterCoordinateY, zoomCenterCoordinateX, zoomImageRate, username, password, ipAddress, imageAnalysisLastFloodDetectedStatus_1, imageAnalysisLastFloodDetectedStatus_2, imageAnalysisResponse_1, imageAnalysisResponse_2 } = targetSensor.data;

  useEffect(() => {
    fetchImageData();
    const interval1 = intervalRef1.current;
    const interval2 = intervalRef2.current;
    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, [targetSensor.id]);

  const fetchImageData = async () => {
    try {
      const [dataCamera1, listPastFloodImageKeyCamera1Response] = await Promise.all([
        apiListCameraSensorHistories6hAgo(targetSensor.id),
        apiListCameraImagePastFlood(targetSensor.id)
      ]);
      const hasImagesCam1 = listPastFloodImageKeyCamera1Response.data && listPastFloodImageKeyCamera1Response.data.length > 0;
      const listKeyCamera1 = dataCamera1.data.map((item) => item.keyImage);
      const images6hAgoCamera1 = removeRandomElements(listKeyCamera1);
      setListImageKey6hAgoCamera1(images6hAgoCamera1);
      const lastImageCamera1 = listKeyCamera1[listKeyCamera1.length - 1];
      const listPastFloodKeyCamera1 = removeRandomElements(listPastFloodImageKeyCamera1Response.data.map((item) => item.key));
      setListPastFloodImageKeyCamera1([...listPastFloodKeyCamera1, lastImageCamera1]);
      let hasImagesCam2 = false;
      if (typeCamera === "DOUBLE") {
        const [dataCamera2, listPastFloodImageKeyCamera2Response] = await Promise.all([
          apiListCameraSensorHistories6hAgo(targetSensor.id, 2),
          apiListCameraImagePastFlood(targetSensor.id, 2)
        ]);
        hasImagesCam2 = listPastFloodImageKeyCamera2Response.data && listPastFloodImageKeyCamera2Response.data.length > 0;
        const listKeyCamera2 = dataCamera2.data.map((item) => item.keyImage);
        const images6hAgoCamera2 = removeRandomElements(listKeyCamera2);
        setListImageKey6hAgoCamera2(images6hAgoCamera2);
        const lastImageCamera2 = listKeyCamera2[listKeyCamera2.length - 1];
        const listPastFloodKeyCamera2Data = removeRandomElements(listPastFloodImageKeyCamera2Response.data.map((item) => item.key));
        setListPastFloodImageKeyCamera2([...listPastFloodKeyCamera2Data, lastImageCamera2]);
      }
      if (hasImagesCam1 || hasImagesCam2) {
        setShowPastFloodButton(true);
      } else {
        setShowPastFloodButton(false);
      }
    } catch (error) {
      setShowPastFloodButton(false);
    }
  };

  const getUrls = async (list = []) => {
    const urls = await Promise.all(
      list.map(async (key) => {
        try {
          const res = await getUrl({ key });
          return res.url.toString();
        } catch (error) {
          return null;
        }
      })
    );
    return urls.filter(url => url !== null);
  };

  function removeRandomElements(array = []) {
    if (array.length > 80) {
      let numberOfElementsToRemove = array.length - 80;
      let itemsToRemove = [];
      while (itemsToRemove.length < numberOfElementsToRemove) {
        const randomIndex = Math.floor(Math.random() * (array.length - 2)) + 1;
        const randomItem = array[randomIndex];
        if (!itemsToRemove.includes(randomItem)) {
          itemsToRemove.push(randomItem);
        }
      }
      return array.filter((item) => !itemsToRemove.includes(item));
    }
    return array;
  }

  const getIntervalTime = (list) => (list.length <= 40 ? 500 : (20 * 1000) / list.length);

  const startSlide = async (list, setImageSrc, intervalRef, endSlide) => {
    if (list.length <= 1) {
      endSlide();
      return;
    };
    const urlList = await getUrls(list);
    if (urlList.length === 0) {
      endSlide();
      return;
    }
    setTypeDisplayCamera("IMAGE");
    let index = 0;
    const intervalTime = getIntervalTime(urlList);
    intervalRef.current = setInterval(() => {
      setImageSrc(urlList[index]);
      index = (index + 1) % urlList.length;
      if (index === 0) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        endSlide();
      }
    }, intervalTime);
  };

  const handleRunSlide = (list1, list2) => {
    let slide1Completed = false;
    let slide2Completed = false;
    const endSlide = () => {
      if (slide1Completed && (slide2Completed || typeCamera !== "DOUBLE")) {
        if (targetSensor.data.typeDisplayCamera === "VIDEO") {
          setTypeDisplayCamera("VIDEO");
        }
      }
    };
    startSlide(list1, setImage1Src, intervalRef1, () => {
      slide1Completed = true;
      endSlide();
    });
    if (typeCamera === "DOUBLE") {
      startSlide(list2, setImage2Src, intervalRef2, () => {
        slide2Completed = true;
        endSlide();
      });
    }
  };

    const handleDownloadVideo = async (videoKey) => {
      if (!videoKey || videoKey.includes('undefined')) {
      error('ビデオが見つかりません。');
      return;
    };

    try {
      setLoading(true);
      const url = await getUrl({
        key: videoKey,
        options: {
          validateObjectExistence: true
        }
      });
      const response = await fetch(url.url.toString());
      const blob = await response.blob();
      const videoName = url.url.pathname.split('/').pop();

      downloadBlob(blob, videoName);
    } catch (error) {
      error(DIALOG_ERROR_GENERAL_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  }

  const buttonComponent = ({ condition, label, icon, toolTipContent, toolTipStyle, wrapperStyle, ...props }) => {
    const defaultCondition = generalSetting?.cameraWindowButtonOn;
    if (!condition || !defaultCondition) return null;
    return (
      <div className="base-page-camera-btn-wrapper" style={wrapperStyle}>
        <button className="base-page-flex-row base-page-camera-btn" {...props}>
          <span>{label}</span>
          {icon && <Icon icon={icon} />}
        </button>
        {toolTipContent && (
          <div className="base-page-camera-btn-popup" style={toolTipStyle}>
            {toolTipContent}
          </div>
        )}
      </div>
    );
  };

  const subComponent = ({ src, size, cameraNumber, videoKey }) => {
    return (
      <>
        <ZoomDataCapture size={size} setZoomData={setZoomData} />
        <div className="base-page-camera-card-btn-group">
          {buttonComponent({
            condition: true,
            label: "過去画像",
            onClick: () => {
              onViewSensorDetail(targetSensor, { cameraNumber });
            },
          })}
          {buttonComponent({
            condition: currentUser?.data?.maximizeVideo,
            label: "現在の動画",
            toolTipContent: typeCamera !== "DOUBLE" ? "長時間の動画閲覧は月額通信量を超過し通信速度が低下します" : "",
            onClick: () => {
              if (typeDisplayCamera === "VIDEO") {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/mjpg/video.cgi?camera=${cameraNumber}`;
                window.open(location, "_blank");
              } else {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${cameraNumber}`;
                window.open(location, "_blank");
              }
            },
          })}
          {buttonComponent({
            condition: currentUser?.data?.recordedVideo,
            label: "録画動画",
            onClick: () => {
              const location = `http://${ipAddress}/camera/index.html#/recordings`;
              window.open(location, "_blank");
            },
          })}
          {buttonComponent({
            condition: true,
            label: "直近6時間",
            onClick: () => {
              handleRunSlide(listImageKey6hAgoCamera1, listImageKey6hAgoCamera2)
            },
            disabled: intervalRef1.current || intervalRef2.current,
          })}
          {buttonComponent({
            condition: showPastFloodButton,
            label: "過去登録時",
            onClick: () => {
              handleRunSlide(listPastFloodImageKeyCamera1, listPastFloodImageKeyCamera2)
            },
            disabled: intervalRef1.current || intervalRef2.current,
          })}
          {currentUser?.accountType === AccountType.ADMIN && (
            <button className='camera_diplayer_item_buttons-download_video'  onClick={() =>handleDownloadVideo(videoKey)}>
              <FontAwesomeIcon icon={faDownload} style={{height: '20px'}} className='base-page-camera-btn'/>
          </button>
          )}
        </div>
      </>
    );
  };

  return (
    <div className="base-page-camera-card">
      {loading && createPortal(<FanLoadingIcon />, document.body)}
      {cameraFeature && (
        <div className={`base-page-camera-card-displayer ${zoomImageFeature && zoomData.size ? 'has-zoom' : ''}`}>
          {/* Camera 1 */}
          <div className="base-page-camera-card-displayer-wrapper">
            <CameraDisplayer
              targetSensor={targetSensor}
              cameraNumber={swapImageCamera ? 2 : 1}
              isDisplayVideo={typeDisplayCamera === "VIDEO"}
              isImageAnalysis={false}
              style={{ width: "100%" }}
              imageProps={{
                key: swapImageCamera ? keyNewestImage2 : keyNewestImage,
                src: swapImageCamera ? image2Src : image1Src,
              }}
              buttonStatusProps={{
                status: {
                  color: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.color,
                  value: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_2 : imageAnalysisLastFloodDetectedStatus_1]?.value,
                },
                toolTipContent: swapImageCamera ? imageAnalysisResponse_2 : imageAnalysisResponse_1,
              }}
              subComponent={subComponent}
              videoProps={{
                useFor: 'base'
              }}
            />
            <div
              className="base-page-camera-card-displayer-above"
              onClick={() => {
                const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${swapImageCamera ? 2 : 1}`;
                window.open(location, "_blank");
              }}
            ></div>
          </div>
          {zoomData.size && zoomImageFeature 
          && ((zoomTargetCamera === TARGET_ZOOM_CAMERA.CAMERA1 && !swapImageCamera) || (zoomTargetCamera === TARGET_ZOOM_CAMERA.CAMERA2 && swapImageCamera)) 
          && (
            <ImageZoom
              zoomData={zoomData}
              zoomImageFeature={zoomImageFeature}
              zoomImageRate={zoomImageRate}
              zoomCenterCoordinateX={zoomCenterCoordinateX}
              zoomCenterCoordinateY={zoomCenterCoordinateY}
              imageProps={{
                key: (swapImageCamera) ? keyNewestImage2 : keyNewestImage,
                src: (swapImageCamera) ? image2Src : image1Src,
              }}
            />
          )}
          {/* Camera 2 - Only show if DOUBLE camera type */}
          {typeCamera === "DOUBLE" && (
            <div className="base-page-camera-card-displayer-wrapper">
              <CameraDisplayer
                targetSensor={targetSensor}
                cameraNumber={swapImageCamera ? 1 : 2}
                isDisplayVideo={typeDisplayCamera === "VIDEO"}
                isImageAnalysis={false}
                style={{ width: "100%" }}
                imageProps={{
                  key: swapImageCamera ? keyNewestImage : keyNewestImage2,
                  src: swapImageCamera ? image1Src : image2Src,
                }}
                buttonStatusProps={{
                  status: {
                    color: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.color,
                    value: targetGroup?.messages[swapImageCamera ? imageAnalysisLastFloodDetectedStatus_1 : imageAnalysisLastFloodDetectedStatus_2]?.value,
                  },
                  toolTipContent: swapImageCamera ? imageAnalysisResponse_1 : imageAnalysisResponse_2,
                }}
                subComponent={subComponent}
                videoProps={{
                  useFor: 'base'
                }}
              />
              <div
                className="base-page-camera-card-displayer-above"
                onClick={() => {
                  const location = `http://${encodeURIComponent(username)}:${encodeURIComponent(password)}@${ipAddress}/axis-cgi/jpg/image.cgi?camera=${swapImageCamera ? 1 : 2}`;
                  window.open(location, "_blank");
                }}
              ></div>
            </div>
          )}
          {zoomData.size && zoomImageFeature 
          && ((zoomTargetCamera === TARGET_ZOOM_CAMERA.CAMERA2 && !swapImageCamera) || (zoomTargetCamera === TARGET_ZOOM_CAMERA.CAMERA1 && swapImageCamera))
          && (
            <ImageZoom
              zoomData={zoomData}
              zoomImageFeature={zoomImageFeature}
              zoomImageRate={zoomImageRate}
              zoomCenterCoordinateX={zoomCenterCoordinateX}
              zoomCenterCoordinateY={zoomCenterCoordinateY}
              imageProps={{
                key: (swapImageCamera) ? keyNewestImage: keyNewestImage2,
                src: (swapImageCamera) ? image1Src: image2Src,
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

const BasePage = ({ onViewSensorDetail }) => {
  const { id: sensorId } = useParams();
  const [currentSensor, setCurrentSensor] = useState(null);
  const [loading, setLoading] = useState(true);
  const { generalSetting } = useGeneralSetting();
  const { sensorGroups } = useSensorGroups();
  const [targetGroup, setTargetGroup] = useState(null);
  // Map reference for capturing
  const mapRef = useRef(null);

  useEffect(() => {
    let isMounted = true;
    const fetchSensor = async () => {
      if (sensorId) {
        setLoading(true);
        try {
          const res = await apiGetSensor(sensorId);
          if (isMounted) {
            if (res.success && res.data) {
              const sensorData = res.data;
              sensorData.latitude = sensorData.lat || 21.028511;
              sensorData.longitude = sensorData.lng || 105.804817;
              setCurrentSensor(sensorData);
            } else {
              setCurrentSensor(null);
            }
          }
        } catch (error) {
          if (isMounted) setCurrentSensor(null);
        } finally {
          if (isMounted) setLoading(false);
        }
      }
    };
    fetchSensor();
    return () => { isMounted = false; };
  }, [sensorId]);

  useEffect(() => {
    if (currentSensor && sensorGroups) {
      const group = sensorGroups.find((g) => g.id === currentSensor.groupId);
      setTargetGroup(group);
    }
  }, [currentSensor, sensorGroups]);


  const onDownloadExcel = async (templateType, datasets, filename, selectedDate) => {
    try {
      setLoading(true);

      let imgData = null;
      try {
        const req = await downloadData({
          key: `counted_camera_imgs/${sensorId}`,
        }).result;
        const blob = await req.body.blob();
        if (blob) {
          const imageBlob = await req.body.blob();
          imgData = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(imageBlob);
          });
        }
      } catch (error) {
        console.error("Error downloading image from storage:", error);
        // Handle specific error codes 404
        const statusCode = error.metadata?.httpStatusCode;
        if (statusCode !== 404) imgData = null;
      }

      const strDay = moment(selectedDate).format('YYYY年MM月DD日(ddd)');
      let sensorData = {
        sensorName: currentSensor.name || 'No Information',
        createAt: strDay,
        datasets,
      };

      await downloadExcelWithSensorData(templateType, imgData, sensorData, filename);

    } catch (error) {
      console.error("Error downloading Excel:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="base-page-container" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <FanLoadingIcon size={80}/>
      </div>
    );
  }

  if (!currentSensor) {
    return <div className="base-page-detail-header">Sensor information not found.</div>;
  }

  const isCamera = targetGroup?.type === SensorType.CAMERA;
  const sensorLocation = currentSensor && currentSensor.latitude && currentSensor.longitude ? { lat: currentSensor.latitude, lng: currentSensor.longitude } : null;

  return (
    <div className="base-page-container">
      <div className="base-page-detail-header-row base-page-detail-header">
        <div className="base-page-detail-header-row base-page-detail-header-title">
          <div className="base-page-detail-header-row base-page-detail-header-symbol">
            <Icon icon={IconList.iconListingDetail} />
            <label className="base-page-detail-header-text">{TEXT_BASE_DISPLAY}</label>
          </div>
          <Icon icon={IconList.iconAllowDetail} />
        </div>
        <div className="base-page-detail-header-row">
          <IconSensor
            color={targetGroup?.messages?.[currentSensor.status]?.color || '#0A3D71'}
            type={targetGroup?.type}
            sensor={currentSensor}
            position="header"
          />
          <label className="base-page-detail-header-subtitle">{currentSensor.name}</label>
        </div>
      </div>
      <div className="base-page-content-wrapper">
        {targetGroup ? (
          isCamera ? (
            <div className="base-page-camera-and-map-container">
              <div className="base-page-camera-info-container">
                <CameraSensorInfo targetSensor={currentSensor} targetGroup={targetGroup} generalSetting={generalSetting} onViewSensorDetail={onViewSensorDetail} />
              </div>
              {sensorLocation && (
                <div className="base-page-map-container">
                  <MiniMapView ref={mapRef} center={sensorLocation} zoom={25} popupText={`Location of: ${currentSensor.name}`} targetGroup={targetGroup} currentSensor={currentSensor} />
                  <div className="base-page-chart-wrapper">
                    <CameraTrafficVolumeChart sensor={currentSensor} noMargin defaultToHour onDownloadExcel={onDownloadExcel} />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <p style={{ padding: "0 32px" }}>This is a different type of sensor (not a camera).</p>
            </div>
          )
        ) : (
          sensorGroups?.length === 0 ? (
             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <FanLoadingIcon size={80} />
             </div>
          ) : (
            <div style={{ padding: "0 32px" }}>Sensor group information not found.</div>
          )
        )}
      </div>
    </div>
  );
};

BasePage.propTypes = propTypes;
BasePage.defaultProps = defaultProps;
export default BasePage;
